// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options } from '@hey-api/client-fetch';
import { type GetUserError, type GetUserResponse2, type GetSeoByCityTagData, type GetSeoByCityTagError, type GetSeoByCityTagResponse, type GetSeoByCitySlugData, type GetSeoByCitySlugError, type GetSeoByCitySlugResponse, type GetTourSeoByIdData, type GetTourSeoByIdError, type GetTourSeoByIdResponse, type GetSeoFromCityToRegionData, type GetSeoFromCityToRegionError, type GetSeoFromCityToRegionResponse, type GetSeoFromCityToCountryData, type GetSeoFromCityToCountryError, type GetSeoFromCityToCountryResponse, type GetCityInfoBySlugData, type GetCityInfoBySlugError, type GetCityInfoBySlugResponse, type GetRegionsInCountryData, type GetRegionsInCountryError, type GetRegionsInCountryResponse, type GetRegionInfoBySlugData, type GetRegionInfoBySlugError, type GetRegionInfoBySlugResponse, type GetCountryInfoBySlugData, type GetCountryInfoBySlugError, type GetCountryInfoBySlugResponse, type GetCountryFromCitiesInfoData, type GetCountryFromCitiesInfoError, type GetCountryFromCitiesInfoResponse, type GetGuidesData, type GetGuidesError, type GetGuidesResponse, type GetReviewsData, type GetReviewsError, type GetReviewsResponse, type GetRegionTagsData, type GetRegionTagsError, type GetRegionTagsResponse, type GetSeoRegionTagData, type GetSeoRegionTagError, type GetSeoRegionTagResponse, type GetCityTagsData, type GetCityTagsError, type GetCityTagsResponse, type GetCountryTagsData, type GetCountryTagsError, type GetCountryTagsResponse, type GetSeoCountryTagData, type GetSeoCountryTagError, type GetSeoCountryTagResponse, type GetRelatedArticlesByLocationSlugData, type GetRelatedArticlesByLocationSlugError, type GetRelatedArticlesByLocationSlugResponse, type GetCitiesAroundData, type GetCitiesAroundError, type GetCitiesAroundResponse2, type GetCitiesRegionData, type GetCitiesRegionError, type GetCitiesRegionResponse2, type GetListingBannersData, type GetListingBannersError, type GetListingBannersResponse2, type PostChooseTourFormDataData, type PostChooseTourFormDataError, type PostChooseTourFormDataResponse, type GetMovementTypesError, type GetMovementTypesResponse, type GetToursActivitiesError, type GetToursActivitiesResponse, type GetExperienceAggregationsData, type GetExperienceAggregationsError, type GetExperienceAggregationsResponse, type GetExperiencesData, type GetExperiencesError, type GetExperiencesResponse, type GetExperiencesRecommendationsData, type GetExperiencesRecommendationsError, type GetExperiencesRecommendationsResponse2, type GetExperiencesCountData, type GetExperiencesCountError, type GetExperiencesCountResponse2, type GetRelatedExperiencesData, type GetRelatedExperiencesError, type GetRelatedExperiencesResponse2, type AddExperienceToFavoritesData, type AddExperienceToFavoritesError, type AddExperienceToFavoritesResponse, type RemoveExperienceFromFavoritesData, type RemoveExperienceFromFavoritesError, type RemoveExperienceFromFavoritesResponse, type GetFavoriteExperiencesData, type GetFavoriteExperiencesError, type GetFavoriteExperiencesResponse, type GetCitiesToursByRegionData, type GetCitiesToursByRegionError, type GetCitiesToursByRegionResponse2, type GetCalendarEventsChipsError, type GetCalendarEventsChipsResponse2, type GetDisplayCurrenciesError, type GetDisplayCurrenciesResponse, AddExperienceToFavoritesResponseTransformer } from './types.gen';

export const client = createClient(createConfig());

/**
 * Get user data
 */
export const getUser = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<GetUserResponse2, GetUserError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/me/'
    });
};

/**
 * Получить seo информацию по slug города и выбранному тэгу
 */
export const getSeoByCityTag = <ThrowOnError extends boolean = false>(options?: Options<GetSeoByCityTagData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetSeoByCityTagResponse, GetSeoByCityTagError, ThrowOnError>({
        ...options,
        url: '/api/seo/v2/citytag/'
    });
};

/**
 * Получить seo информацию по slug города
 */
export const getSeoByCitySlug = <ThrowOnError extends boolean = false>(options?: Options<GetSeoByCitySlugData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetSeoByCitySlugResponse, GetSeoByCitySlugError, ThrowOnError>({
        ...options,
        url: '/api/seo/v2/city/'
    });
};

/**
 * Получить seo информацию тура
 */
export const getTourSeoById = <ThrowOnError extends boolean = false>(options: Options<GetTourSeoByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetTourSeoByIdResponse, GetTourSeoByIdError, ThrowOnError>({
        ...options,
        url: '/api/seo/v2/{tourType}/'
    });
};

/**
 * Получить seo информацию туров в регион из города
 */
export const getSeoFromCityToRegion = <ThrowOnError extends boolean = false>(options?: Options<GetSeoFromCityToRegionData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetSeoFromCityToRegionResponse, GetSeoFromCityToRegionError, ThrowOnError>({
        ...options,
        url: '/api/seo/v2/from_city_to_region/'
    });
};

/**
 * Получить seo информацию туров в регион из города
 */
export const getSeoFromCityToCountry = <ThrowOnError extends boolean = false>(options?: Options<GetSeoFromCityToCountryData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetSeoFromCityToCountryResponse, GetSeoFromCityToCountryError, ThrowOnError>({
        ...options,
        url: '/api/seo/v2/from_city_to_country/'
    });
};

/**
 * Получить информацию о городе по slug
 */
export const getCityInfoBySlug = <ThrowOnError extends boolean = false>(options: Options<GetCityInfoBySlugData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCityInfoBySlugResponse, GetCityInfoBySlugError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/cities/{citySlug}/'
    });
};

/**
 * Получить информацию о регионах по стране
 */
export const getRegionsInCountry = <ThrowOnError extends boolean = false>(options: Options<GetRegionsInCountryData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetRegionsInCountryResponse, GetRegionsInCountryError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/regions/'
    });
};

/**
 * Получить информацию о регионе по slug
 */
export const getRegionInfoBySlug = <ThrowOnError extends boolean = false>(options: Options<GetRegionInfoBySlugData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetRegionInfoBySlugResponse, GetRegionInfoBySlugError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/regions/{regionSlug}/'
    });
};

/**
 * Получить информацию о стране по slug
 */
export const getCountryInfoBySlug = <ThrowOnError extends boolean = false>(options: Options<GetCountryInfoBySlugData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCountryInfoBySlugResponse, GetCountryInfoBySlugError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/countries/{countrySlug}/'
    });
};

/**
 * Получить информацию о городах, в которые можно поехать из страны
 */
export const getCountryFromCitiesInfo = <ThrowOnError extends boolean = false>(options: Options<GetCountryFromCitiesInfoData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCountryFromCitiesInfoResponse, GetCountryFromCitiesInfoError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/countries/{countrySlug}/from_cities/'
    });
};

/**
 * Получить список гидов
 */
export const getGuides = <ThrowOnError extends boolean = false>(options?: Options<GetGuidesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetGuidesResponse, GetGuidesError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/guides/'
    });
};

/**
 * Получить список отзывов
 */
export const getReviews = <ThrowOnError extends boolean = false>(options?: Options<GetReviewsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetReviewsResponse, GetReviewsError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/reviews/'
    });
};

/**
 * Получить список тэгов для региона
 */
export const getRegionTags = <ThrowOnError extends boolean = false>(options?: Options<GetRegionTagsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetRegionTagsResponse, GetRegionTagsError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/regiontags/'
    });
};

/**
 * Получить SEO инфу по тегу региона
 */
export const getSeoRegionTag = <ThrowOnError extends boolean = false>(options: Options<GetSeoRegionTagData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetSeoRegionTagResponse, GetSeoRegionTagError, ThrowOnError>({
        ...options,
        url: '/api/seo/v2/regiontag/'
    });
};

/**
 * Получить список тэгов для города
 */
export const getCityTags = <ThrowOnError extends boolean = false>(options?: Options<GetCityTagsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCityTagsResponse, GetCityTagsError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/citytags/'
    });
};

/**
 * Получить список тэгов для страны
 */
export const getCountryTags = <ThrowOnError extends boolean = false>(options?: Options<GetCountryTagsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCountryTagsResponse, GetCountryTagsError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/countrytags/'
    });
};

/**
 * Получить SEO инфу по тегу страны
 */
export const getSeoCountryTag = <ThrowOnError extends boolean = false>(options: Options<GetSeoCountryTagData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetSeoCountryTagResponse, GetSeoCountryTagError, ThrowOnError>({
        ...options,
        url: '/api/seo/v2/countrytag/'
    });
};

/**
 * Получить полезные статьи
 */
export const getRelatedArticlesByLocationSlug = <ThrowOnError extends boolean = false>(options?: Options<GetRelatedArticlesByLocationSlugData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetRelatedArticlesByLocationSlugResponse, GetRelatedArticlesByLocationSlugError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/articles/related/'
    });
};

/**
 * Get Cities Around
 * Получить список городов вокруг указанного города
 */
export const getCitiesAround = <ThrowOnError extends boolean = false>(options: Options<GetCitiesAroundData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCitiesAroundResponse2, GetCitiesAroundError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/cities/{cityId}/around/'
    });
};

/**
 * Get Cities Region
 * Получить инфу региона, к которым относится город
 */
export const getCitiesRegion = <ThrowOnError extends boolean = false>(options: Options<GetCitiesRegionData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCitiesRegionResponse2, GetCitiesRegionError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/cities/{citySlug}/banners/'
    });
};

/**
 * Get Listing Banners
 * Получить баннеры для врезки в листинг
 */
export const getListingBanners = <ThrowOnError extends boolean = false>(options?: Options<GetListingBannersData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetListingBannersResponse2, GetListingBannersError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/listing_banners/'
    });
};

/**
 * Post choose tour form data
 * Отправить данные формы обратной связи по турам
 */
export const postChooseTourFormData = <ThrowOnError extends boolean = false>(options: Options<PostChooseTourFormDataData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostChooseTourFormDataResponse, PostChooseTourFormDataError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/experience-suggest/'
    });
};

/**
 * Получить список способов передвижения
 * Получить список типов передвижения, групп типов передвижения и их соответствий
 */
export const getMovementTypes = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetMovementTypesResponse, GetMovementTypesError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/movement-types/'
    });
};

/**
 * Получить список типов активности
 * Получить список типов активности для туров
 */
export const getToursActivities = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetToursActivitiesResponse, GetToursActivitiesError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/tour-activities/'
    });
};

/**
 * Получить агрегации экспириенсов
 * Получить агрегированные данные для экспириенсов
 */
export const getExperienceAggregations = <ThrowOnError extends boolean = false>(options?: Options<GetExperienceAggregationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetExperienceAggregationsResponse, GetExperienceAggregationsError, ThrowOnError>({
        ...options,
        url: '/api/web/v2/experiences/aggregations/'
    });
};

/**
 * Получить все экспериены
 */
export const getExperiences = <ThrowOnError extends boolean = false>(options: Options<GetExperiencesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetExperiencesResponse, GetExperiencesError, ThrowOnError>({
        ...options,
        url: '/api/web/v2/experiences/'
    });
};

/**
 * Получить все рекоммендованные экспериенсы для пустой и малой выдачи
 */
export const getExperiencesRecommendations = <ThrowOnError extends boolean = false>(options: Options<GetExperiencesRecommendationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetExperiencesRecommendationsResponse2, GetExperiencesRecommendationsError, ThrowOnError>({
        ...options,
        url: '/api/web/v2/experiences/empty/'
    });
};

/**
 * Получить количество экспериенсов по фильтрам
 */
export const getExperiencesCount = <ThrowOnError extends boolean = false>(options: Options<GetExperiencesCountData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetExperiencesCountResponse2, GetExperiencesCountError, ThrowOnError>({
        ...options,
        url: '/api/web/v2/experiences/count/'
    });
};

/**
 * Получить связанные экспириенсы
 */
export const getRelatedExperiences = <ThrowOnError extends boolean = false>(options?: Options<GetRelatedExperiencesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetRelatedExperiencesResponse2, GetRelatedExperiencesError, ThrowOnError>({
        ...options,
        url: '/api/web/v2/experiences/related/'
    });
};

/**
 * Добавить experience в избранное
 */
export const addExperienceToFavorites = <ThrowOnError extends boolean = false>(options: Options<AddExperienceToFavoritesData, ThrowOnError>) => {
    return (options?.client ?? client).put<AddExperienceToFavoritesResponse, AddExperienceToFavoritesError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/experiences/{id}/favorite/',
        responseTransformer: AddExperienceToFavoritesResponseTransformer
    });
};

/**
 * Удалить experience из избранного
 */
export const removeExperienceFromFavorites = <ThrowOnError extends boolean = false>(options: Options<RemoveExperienceFromFavoritesData, ThrowOnError>) => {
    return (options?.client ?? client).delete<RemoveExperienceFromFavoritesResponse, RemoveExperienceFromFavoritesError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/experiences/{id}/favorite/'
    });
};

/**
 * Получить список избранных experience
 */
export const getFavoriteExperiences = <ThrowOnError extends boolean = false>(options?: Options<GetFavoriteExperiencesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFavoriteExperiencesResponse, GetFavoriteExperiencesError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/experiences/favorites/'
    });
};

/**
 * Получить seo информацию по турам в городах
 */
export const getCitiesToursByRegion = <ThrowOnError extends boolean = false>(options: Options<GetCitiesToursByRegionData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCitiesToursByRegionResponse2, GetCitiesToursByRegionError, ThrowOnError>({
        ...options,
        url: '/api/seo/v2/category/cities-tours-by-region/{regionSlug}/'
    });
};

/**
 * Получить интервалы дат для чипсов календаря
 */
export const getCalendarEventsChips = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCalendarEventsChipsResponse2, GetCalendarEventsChipsError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/calendar-filters'
    });
};

/**
 * Список валют для переключателя
 * Endpoint доступен без авторизации. Backend возвращает только валюты, доступные для переключателя и имеющие валидный курс.
 */
export const getDisplayCurrencies = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetDisplayCurrenciesResponse, GetDisplayCurrenciesError, ThrowOnError>({
        ...options,
        url: '/api/web/v1/multicurrency/display_currencies/'
    });
};